import type { FC } from 'react'

import type { EmbedFeedParams } from '@core/types'
import { WidgetSizeEnum } from '@core/types'
import { RESPONSIVE_THUMBNAIL_WIDTHS } from '@embed/components/Grid/GridConstants'
import { getThumbnailSize } from '@embed/components/helpers/getThumbnailSize'

import {
  StyledThumbnailContainerV2,
  ThumbnailContainer,
} from './PlayerDeckContainer.styles'
import { PlaceholderInner } from './PlayerDeckPlaceholder.styles'

export interface PlayerDeckPlaceholderProps {
  params: EmbedFeedParams
  responsive: boolean
  columnWidth?: string
}

/**
 * Placeholder for player deck layout that matches actual thumbnail dimensions.
 * Uses the same sizing logic as PlayerDeckContainer.
 */
export const PlayerDeckPlaceholder: FC<PlayerDeckPlaceholderProps> = ({
  params,
  responsive,
  columnWidth,
}) => {
  const [videoThumbWidth, videoThumbHeight] = getThumbnailSize(params.size)
  const size = params.size ?? WidgetSizeEnum.LARGE
  const thumbnailWidth = RESPONSIVE_THUMBNAIL_WIDTHS[size]
  const isGridMode = params.mode === 'grid' && params.player_deck_layout

  return (
    <StyledThumbnailContainerV2
      height={videoThumbHeight}
      responsive={responsive}
      columnWidth={columnWidth}
      maxWidth={thumbnailWidth.maxThumbWidth}
      minWidth={thumbnailWidth.minThumbWidth}
      isGridMode={isGridMode}
    >
      <ThumbnailContainer
        height={videoThumbHeight}
        width={videoThumbWidth}
        responsive={responsive}
        isGridMode={isGridMode}
      >
        <PlaceholderInner
          width={videoThumbWidth}
          height={videoThumbHeight}
          responsive={responsive || isGridMode}
        />
      </ThumbnailContainer>
    </StyledThumbnailContainerV2>
  )
}
